module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "ساندريلا-النور"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ساندريلا النور")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("“لا تحولني لكلماتِ شعرٍ موزون، أو لحنٍ يلتصق بأغنيةٍ واحدة، لا أُريدُ أن أصبحَ لوناً يُحبسُ في لوحة معلَّقةٍ على جدارِ أحدهم، لا أرغب بأسرٍ مضجرٍ بين صفحات رواية تحتفظ بقليل من زمن، ولا يمكن مغادرتها، أريدُ أن أبقى فكرةً، تعبرُ الفضاء وتخرج عن نطاق المألوف، أودُّ أن أتحوَّل لحكاية يتجدَّد مكانها وزمانها وشخوصها عبر الأجيال، ليصيبَّ الفرحَ من يتلذَّذ في تفاصيلها، أحبّ أن يتذكَّرني كلُّ من يعرفني على أنَّني أملٌ جدير بالحياة\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد أن قالت لي ذلك، اعتراني تردُّد وخوف، رعشة أطرافي كانَت عرضاً جانبيّاً لحالة الانتصار الَّتي عشتها، تأكَّدتُ أنَّها شعرَت بما أصابني عندَما أمسكَت بيدي، وتسلَّلَ دفءُ أصابعها ليملأ فراغ الرَّهبة ويعيد التَّوازن، قرَّرتُ عندها المضي في حياةٍ هي بطلتُها، توقَّفتُ عن كتابة الرّواية واستمعْتُ باللَّحظة،")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استبدلْتُ كلَّ شعاراتي الَّتي اعتدتُ التَّغنِّي بها بشيء أهمّ، شيء يُكسِبُ مَن يتبناه احترامَ الذَّات وثباتَ الاستمرار؛ شيء ومعنىً يُطلق عليه حتَّى الآن التحدَّي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يجبُ على كلٍّ منَّا أن يتحدَّى، والبداية الحقيقيَّة هي تحدِّي الدَّاخل، واستخراج قدراتِنا تطويرها، تسخيرها لهدفٍ سامٍ يساعدُنا في الاقتراب من الحقيقة، والحقيقة مفهومٌ من مفاهيم رفاهيَّة الإدراك والمعرفة لا ينعمُ بها إلَّا من وصلَ لنشوة الشعور بأنَّه حيٌّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قصَّتي مع تلك الفتاة غريبةٌ جدّاً، ومع ذلك تشبهُ قصصاً كثيرة رافقَت طفولتي، اعتقدتُ في البدايةِ أنّهاَ قصص أطفال والغاية منها استحضارُ النَّوم، والتغلُّب على نشوة نشاط الطّفولة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منذُ لَّحظة اللقاء الأولى أصابَ روحي تغيُّرٌ جوهري شعرتُ به في نفسي وفي جسدي، في أفكاري الَّتي باتَت أكثرَ انفتاحاً وأكثر شموليَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قبل تلك المرحلةِ ولسنواتٍ امتدَت عبرَ ثلاثةِ عقودٍ تقريباً، كنتُ قد وصلتُ لمكانٍ اعتقدتْهُ قمَّةً؛ ليتبيَّن فيما بعد أنَّهُ بدايةُ الصعود نحوها؛ كتبتُ الكثيرَ من القصص والروايات، بعضُها لاقى نجاحاً ملموساً، في عالمٍ اعتادَ في سنواته الأخيرة تهميشَ القراءة، ودُفن بعضُها الآخر وكأنَّهُ لم يُولَد، قطعتُ شوطاً لا بأسَ به على جميع الجبهات، انتقلتُ من الحيِّ الشَّعبيّ الَّذي رافق انطلاقتي لحيٍّ آخر يحملُ قصصا أخرى، وتحوَّلَ ليُصبحَ موطني الجديد بعدَ شعورٍ دام شهوراً بالغُربة فيه، أمَّا على صعيد العمل، وبعدَ سنواتٍ من العمل في ظلال المبتدئين، بدأتُ بكتابة زاويةٍ ثابتة في إحدى الصُّحفِ المرموقة. لا أصنِّف نفسي شخصاً انطوائياً أو انعزالياً، أجدُ لجوئي للوحدة أساساً لانطلاق أفكاري الَّتي تتزاحمُ منذُ زمنٍ بعيد في داخلي، لستُ شخصاً شديد النَّشاط الاجتماعي؛ فأنا لا أملك ميزةَ المثابرة لنيل ذلك اللَّقب، أؤمن بحاجةِ الأفراد وتكاملها لأداءِ فرائض الحياة، وأعمل على أن تكون تلك الحاجة في حدودها الدُّنيا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعتقدُ أنَّ هذه الخاصيَّة هي الَّتي تُفسِّر عزوفي عن الزَّواج، في زمنٍ تداعى فيه أصدقائي الواحدَ تلو الآخر في بحره، أجبرتُ نفسي في مصادفاتٍ مُتعدّدة، وثَّقْتُ بعضَها، على وصف علاقتي بالنَّساء، كان ذلك صعباً مبهماً يحتاجُ لكثيرٍ من البحث والصِّدق والتبحُّر في علوم التَّاريخ والاجتماع والطبِّ والأحياء، دارت جميعُ أفكارها حول محور واحدٍ، وجاءت كالتَّالي: \"الاختلاف بينَنا نحن الذّكور وبين الإناث واضحٌ بأبعاد تتجاوزُ الشَّكل والمضمون، اختلاف يصلُ للأحلام وتفسيرها، والسير نحوها؛ أعتقدُ أنَّ الإناث كائناتٌ مُحَجَّمَة التَّفكير، لا تتطابق مع امتدادات تفكيرنا -نحن الذّكور-التي يمكن أن تصل لأعتاب بعيدةٍ عن الواقع الملموس، هناك استثناءات لأمتدادات أنثوية ملموسة، بعضُها يُعتبَر شاذّاً عن الواقع، وبعضها الآخر يطرح أفكاراً جديرةً بالاحترام، لم أُنكِر أنَّ ما فعلَتْهُ النّساء وما زالت، في مختلف مجالات الحياة له نكهةٌ مختلفة، فقراءةُ الأدبِ بقلم نسائيّ يطرق الكثيرَ من الزَّوايا الَّتي نغفلُها نحن الرِّجال بغير قصد، إلَّا أنَّ النَّتيجةَ واضحةٌ ولا تحتاج لبحث معمَّقٍ: أشواطُ تقدُّمنا في الإنجاز الحضاريّ لا يمكنُ للنساء تقليصها إلا بعشراتِ السّنين من العمل والمُثابرة والإبداع\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وأعودُ بعد ذلك، مدفوعاً بالصِّدق مع الذَّات، لأناقضَ كلَّ تلك الحقائق: \"لا يمكن لأيٍّ منّا أن يعيش دون إضافة النَّكهات، الَّتي تجيدُ النِّساء صنعها، قصور نتاجهنَّ الحضاريّ يمكنُ أن يُعلَّل بطرقٍ كثيرة، أبدعت العديدات منهنَّ بشرحه، ويجب أيضاَ ألَّا نُنكرَ أنَّ التاريخَ يُكتَبُ بقلم الأقوياء الَّذين يهملون عن قصدٍ أهميَّة الحالات المُنافسة الأخرى، \"")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("علاقاتي الغراميَّة، حتَّى لحظة لقائي بها، متواضعةٌ جدّاً، لم تدخلْ إحداها نطاقَ الرّوح، تجارب صبيانيَّة، وأطياف مراهقةٍ، كتبتُ في نهاية إحداها ما يلي: “تعيشُ النِّساء ضمن قوقعة، يطلقْنَ عليها اسم المشاعر، ليخفيْنَ في جوفها فشلَهنَّ بإتقان فنِّ المناورة الَّذي بات يُعتَبرُ عاملاً ناظماً لمسار الحياة، ينظرْنَ للذّكورِ نظرةَ إعجابٍ، تقترب من التَّأليهِ، نستغلُّها نحن بدورنا، لنفرضَ قوانين صارمةً، ونتفنَّنُ بتمثيل ردودِ أفعالٍ متناقضة، عند شعورنا بالملل أو عدم التلاؤم مع أنثى تبالغُ بمشاعر الودِّ، والرَّغبة في التملُّك\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أكُن قد وصلتُ بعد، لعتبةِ البحثِ عن زوجة، أو لنَقُل شريكةَ حياةٍ، قوانين هذه العلاقة -علاقة الذّكور بالإناث- وطقوسها الحاليَّة، شكَّلَت لي فضاءً غيرَ مفهوم، فنحن الرِّجال مثلاً، تسيطر علينا حالةٌ غير مفهومةٍ في حضرةِ الجمال، نفقُد فيها الكثيرَ من مهاراتِ المحاكمة والتَّفكر، ونتحوَّل لفرائسَ سهلةِ المنال أمام سحرِ ما تملكه النِّساء من جمال وبراءة! والأعجب من ذلك هو حال النِّساء؛ لأنهنَّ يستغنيْنَ عن الكثير من طموحاتِهنَّ عندَ الالتقاء بأيِّ رجل يفتحُ أمامهنَّ، بابَ حياةٍ مختلفةٍ، أعتقدُ أنَّ العلاقة من منظور المنطقِ يجبُ أن تكونَ علاقة أحجيَّةٍ تكمِّلُ نهاياتها نهايات أخرى وتتطابقُ معها، في هذه الحالة يمكنُ أن نحكمَ على تلك العلاقة أنَّها علاقةُ وجودٍ حقيقي، هذا ما يُمليهِ العلمُ والمنطق الَّذي يختلفُ عن الواقع؛ ما يحدثُ في الواقع أنَّ أحدَ الطَّرفين يقومُ بقصِّ نهاياته للتَّطابق مع آخر، وهكذا تُبنى العلاقة على تشوِّهٍ وإقصاءٍ منذُ البداية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اعتدتُ التغلُّبَ على الفراغ العاطفيّ، بتواصُلٍ جيّدٍ مع أصدقاء يمثِّلون عالمي البهيج، وتحوَّلوا مع الزَّمن ليُصبِحوا عائلتي عوضاً عن تلك الَّتي خطفَها منّي الزَّمن باكراً، وتركني وحيداً أُصارِعُ أمواجَه العاتية، وحتَّى تلك اللَّحظة، لحظة رؤيتها، لم يُخامرْني شكٌّ بأنَّ أحدَهم سيلعبُ دوراً قريباً من البطولة في قصَّة حياتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تلقَّيتُ منه \"صديقي المعني بالوصف السَّابق\"، دعوةً لحضورِ زفافه، هو شابٌّ قريبٌ من قلبي، أعتزُّ بصداقته رغمَ أنّي لا أعرفُ الكثيرَ من تفاصيل شخصيَّته الَّتي أعتبرُها ككاتب شخصيَّةً مركَّبةً، تعارفْنا في المدرسة وامتدَّت صداقتُنا لتشملَ مرحلتَنا الجامعيَّة وما بعدها، ناضلَ الشابُّ وعمل بجدٍّ ليصنعَ اسماً استحقَّ الاحترام في طبِّ العيون، وها هو صديقي يحبسُ نفْسَهُ في القفص الذَّهبيّ بملء إرادته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانّ العالَمُ حتَّى تلك اللَّحظة طبيعيّاً وخاليّاً من السِّحر، حَضَرْتُ في الوقت المناسب، وجلستُ في مكاني المُخصَّص، ودخلتُ في عادتي الَّتي أكسبتني حِرَفِيّة جيدةً في الكتابة، وهي المراقبة الدَّقيقة للوجوه ومحاولة استقراء المشاعر، أجواءُ الفرحِ وصلَت مستوياتها المعتادة في مناسبةٍ كهذه، اجتماعُ الأصدقاء القُدامى أضافَ نكهةً لذيذةً للحدث، وفجأةً حلَّ السِّحرُ، فتاةٌ أجبرَت الجميعَ على مراقبةِ فرحها، رقصَت كغجريَّة هاربةٍ من قِصص قديمة، جمعَت ألوانُ ثوبها تناقضاً غريباً لا يجرؤ على جمعها إلَّا مَن تعرَّف أسرارَ الألوان، تناثرَ شعرُها في أبعادٍ أربكَتْ جميعَ من تابعه، ابتسامتُها السَّاحرة رُسمَت بريشة فنَّان، وبَقِيَت عاملاً شديد التأثير في دقائق رقصِها العشر، واختفت في قمَّةِ الفرح الَّذي نثرَتْهُ، اختفَت! بحثتُ عنها، زرتُ كلَّ الأماكن المتاحةِ بنظرةِ بحثٍ دقيقة، لاحقتُ بقايا فرحٍ مبعثَر دون جدوى، أخبرتُ نفسي أنَّها قريبةٌ، شعرتُ بقربها، إلَّا أنَّي لم أستطع العثورَ عليها، تذكَّرتُ قصَّة سندريلا واختفاءها بعد أن ألهَبت قلب الأمير، وبدأتُ رحلةُ البحثِ عن حذائها الزّجاجيّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليتني وجدتُ ذلك الحذاءَ؛ لأنَّه الدَّليل الَّذي ساعدَ الأمير في البحث عنها، وأثبت له أنَّها لم تكن خيالاً أو توهُّماً، غادرتُ بعد أن وعدْتُ نفسي بابتكارِ طُرقٍ مناسبةٍ للحصول على تلك السندريلا الَّتي على ما يبدو، لم تخطفْ قلبَ أمير واحدٍ فقط.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وضعتُ خططاً منطقيَّةً اعتمدتُ فيها على معلوماتِ الحدث وحيثياته، فالمدعون في مجملِهم يُقسمَون إلى قسمين، الأقرباء والأصدقاء، ولأنّي على درايةٍ تامَّة بالأصدقاء فلا بُدَّ أنَّها من الأقرباء، ولكن ماذا لو كاَنت من صديقات العروس مثلاً؟ هل أسألُ عنها صديقي وعروسه؟ اعتقدْتُ حينها أنَّه الحلُّ المنطقيُّ والمُجدي، إلَّا أنَّه وجَب عليَّ الانتظار لعودة العروسين من شهر العسل والسُّكَّر، أو أيّاً كان اسمه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سيطرَ على ذهني هاجسُ البحثِ وعدم الانتظار، قرَّرتُ تمشيط الشَّوارع القريبة من منزل صديقي، لعلَّ الصُّدفةَ تسوقُ لي تلك الجميلة، زرتُ كليَّة الصّحافة، وكليَّة الطبّ، لم أمتلك تبريراً منطقياً لذلك إلَّا أنَّني فعلت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زرتُ كليَّة الفنون الجميلة أيضاً، انحصرَ تبرير ذلك بجرأةِ الألوان وغرابتها، وقفتُ أمام المتاجر المتخصِّصة ببيع الملابس النسائيَّة، وحاولتُ العثور على ثيابٍ تشبه ما ارتدته في الحفل، واعتقدتُ أنَّ العثورَ على ملابسها بمثابة العثور على حذاء سندريلا، إلَّا أنَّ الحظَّ كان بعيدا جدّاً عني.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلستُ في الحدائق، تخيَّلتُ قدومها، راقبتُ منابعَ السّحر في السَّماءِ والأشجار والأزهار، وجاءَ الاستسلام سريعاً، عدتُ للانتظار، وتفنَّنتُ في إبداع جُملٍ تصفُه، وتصفُ ما يتركُه في القلب من حروقٍ لا يمكنُ التَّغاضي عنها، حتَّى لو تشاغلنا في أمور أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعثتُ لها بعدَّة رسائلٍ على أثير المحطَّات الإذاعيَّة المحليَّة، متمنيّاً أن تعرفَ نفسها، وتشفق على مَن أرسلها، أرسلتُها بلا اسم وبلا عنوان، أرسلتُها طيراً مسافراً يحملُ الكثير من الحبّ، رسمتُ لنفسي وبنفسي صورةً لعاشقٍ يعيش حالةً من الولَهِ الجدير بروايته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تأخَّر صديقي، وأثارَتْ أسئلتي عنه فضولَ جميعِ الأصدقاء، قًدَّمْتُ لإرضائه أسباباً مَرَضِيَّة، وإرهاقاً في العيون، بعدَ أيَّامٍ قليلةٍ جاءني اتّصاله متسائلاً عن تعبٍ أعاني منه نقلَ صداهُ بعضُ الأصدقاء، حصلتُ منه بعد جُملٍ مقتضبةٍ، على موعدٍ خصَّصه لي في عيادته، وحانَتِ اللَّحظةُ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الحوار الَّذي قمتُ بإعداده تميَّز بالبساطة والصراحة، اعتمدتُ فيه على خصائص مجتمعيَّة تنصُّ على أنَّه من الطَّبيعي أن يقصَّ الأصدقاءُ، خاصّة إذا كانوا من الذّكور، حالاتِ الإعجاب الَّتي يشعرون بها تجاه فتاةٍ ما، ومن الطبيعي أيضاً سماعُ بعضِ الكلمات والجُمل التَّهكميَّة، والبحث عن خُطط للإيقاع بتلك الفتاة المقصودة بشِباكِ الباحث عنها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأَ الحديث عادياً، تناولنا فيه مزايا الزَّواج، ومخاوفَ المستقبلِ، ثمَّ انتقلنا للحديث عن الأعراض الَّتي أُعاني منها، وهنا كان لا بُدَّ من الجُرأةِ، للتخلُّص من تلك النَّار الَّتي طالَت أماكنَ واسعة من روحي، طرحتُ سؤالي بشكلٍ مباشر:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من تلكَ الفتاة السَّاحرة الَّتي فتنَتِ الجميعَ برقصها؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَ صديقي، تقلَّب في مكانه كثيراً، يبدو أنَّ هناك كثيرين قبلي طرحوا عليه سؤالاً مشابهاً، وأخيراً جاءَتِ الإجابةُ مُقتضِبَة قاصفةً:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّها أختي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في هذه الحالة، وفي عالمِ الذّكور، يجب أن تنقلبَ جميعُ موازين الصَّداقة السَّالفة الذِّكر، يجب أن أعتذرَ عن إعجابي بأُختِه، ويجبُ أن أغيِّرَ مجرى الحديث، المفارقة الجديدة الَّتي وقعتُ ضحيَّتها، أنَّ ذلك لم يحدثْ، وتابعتُ حديثي بشكلٍ طبيعي:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعرفُكَ منذُ زمنٍ، لم تذكرْ أنَّ لك أُختاً بهذا الجمال!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ الطَّبيب بشيءٍ من الحزنِ والرَّغبة بإنهاء الحديث:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أعتدِ الخوضَ في الأمور العائليَّة، وأعتقدُ أنَّك أيضاً تُفضِّلُ ذلك.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استجمعتُ الكثيرَ من القوَّةِ، وانطلقتُ بحديثٍ يعبِّرُ عن نفسي:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("علاقتي بالفتيات تتَّصفُ بالكثير من الجدليَّة، وأنتَ على درايةٍ بذلك، تأثير تلك الفتاة \"أُختكَ\" لم أختبرْهُ سابقاً، أعتقدُ أنّي وقعتُ في حبّها! أعلنُ لكّ ذلك؛ لأنَّكَ تعرفني جيّداً، وتعرفُ أنّي سأحترمُ جميعَ المبادئ الأخلاقيَّة، وأعوام صداقتنا وأبعاد شخصيَّتها، (تمهَّلتُ، وزدتُ من نغمةِ الإصرار، ثمَّ قلتُ): أعدكُ أنَّني سأنسحبُ بكلِّ هدوءٍ إذا اكتشفتُ أنَّها غير مهتَّمة بتلك المشاعر، أو إذا فشلتُ في بناءِ جسرِ تواصُلٍ جيّد بيننا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعَني صديقي، وكأنَّه يدلُّني على طريقِ الصَّواب الَّذي غفلتُ عنهُ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أُختي عمياء!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا أعرفُ دلالةَ تكرار الكلام، ولكن هذا ما حدث:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عمياء!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استأنفَ صديقي حديثَهُ مُتحاشياً أيَّ تواصُلٍ بصريّ بيننا:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تصغرُني \"ميا\" بسبعةِ أعوامٍ، ولدَت كأيِّ فتاةٍ أُخرى، تمتلكُ جميعَ الحواسّ، تنبَّأ الجميعُ بشدَّةِ جمالها، كانَت طفلة ترسمُ الفرح أينما حلَّت، انتهَت مرحلة طفولتها الأولى وهي ترى بكلِّ وضوح، بعد ذلك، بدأَت تُحدِّثُنا عن معاناتِها مع ضعف الرّؤية، وبعدَ أشهرٍ أصبحَت تُكرِّر أنَّها لا ترى شيئاً عندما يحلُّ المساء، سعى والدي بها للعديد من الأطبَّاء والمستشفيات، وشُخِّصتِ الحالةُ على أنَّها التهاب الشبكيَّة الصباغي؛ هي حالةٌ مرضيَّة تتعلق بمجموعة من الطفرات الوراثية، يفقدُ فيها المصاب القدرةَ على الرّؤية تدريجيّاً، إلى أن يصل للعمى التامِّ، تحوَّلت الطِّفلةُ الجميلة لوردة ذابلة، شعرنا بالحزن، بَكيتُ كثيراً لحالها، وكانَت دافعي الأهمّ لدراسةِ طبّ العيون، هي فتاة قويَّة، استعادَت توازنَها بسرعة، وأعادَت لنا أملاً أضعناه عندَما أضاعت رؤيتها، أثبتَت لنا أنَّ البصيرة الجيّدة لا تحتاج لعينين سليمتين، تغنّي بصوتٍ شجيّ، تعزفُ بأنامل مرنة، وتكتبُ أفكارها الهاربة من رؤية قديمة، ما زال حضورُها يضيفُ نوراً ويشعُّ دفئاً، (تنهَّدَ الطّبيب بعمقٍ، نظرَ إليَّ وأضاف): لستَ أوَّلَ مَن يسأل عنها، أعرفُ أنَّها جميلةٌ جدّاً، وأعرفُ أنَّها تسلب أنفاسَ من يلاحظُ تفاصيل ذلك الجمال..")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَ الرَّجلُ قليلاً وأضاف:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اعتدتُ بعدَ سردِ قصَّتها لمن يسأل عنها، مراقبةَ حدودِ الخوف الَّذي ينتابُه، يتيحُ ذلك لي زمناً، أُعدُّ نفسي فيه لأعذرَ تراجعهُ.ابتسمَ صديقي ابتسامةً احترتُ في تصنيفها، لم تكُن ابتسامةَ مهزومٍ أو منتصرٍ، أعتقدُ أنَّها ابتسامةُ حزنٍ، وقالَ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ أيضاً سمعتَ القصَّة، لن تتأثَّرَ صداقتُنا إذا رغبتَ بالانسحاب.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسبَ روايةِ صديقي؛ كانَ من المُفترَض أن أشعرَ بتراجُعِ القوَّة الَّتي دفعَتني للاعتراف بإعجابي، والحقيقة أنَّ ذلك لم يحدث، شُحذَتِ القوَّة وتزايدَت بدافعٍ غريب، لم أعرفْ ماهيَّته أو جوهره، سيطرت على تفكيري حالةُ عمقٍ مهيبة، ورؤيا عابرة للرّوح، حزمتُ أمري:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما أطلبُه، أن تُتاحَ لي فرصةُ اللّقاء بها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شاهدتُ نظراتِ صديقي التحذيريَّة، عاجلتُه بكلماتي قبلَ أن ينطقَ كلماتِه:أعدُكَ أنّي سأتحمَّلُ المسؤوليَّة المناطة بي كاملة، لن أتسبَّب لها بأيِّ أذىً!")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وافقَ صديقي على طلبي، بعدَ أن وافقَت ميا بدورها عليه، انطلقتُ للقائي الأوَّل مع نجمةٍ سرقَتِ الألقَ وأجبرتني على اللَّحاق بها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طلبَ صديقي أن يكون اللّقاء في محيطٍ مألوفٍ بالنّسبة لها، لأنَّ ذلك يكسبُها راحةً وثقة، يمكنُها أن تلعب دوراً جيداً في التَّخفيفِ من حدَّة التوتُّر. حدثَ اللّقاء في غرفةٍ تابعةٍ للمنزل تتَّخذها ميا مكاناً للعمل، لم أفهم في البداية ماهيَّة العمل المقصود؛ ثمَّ بدأتُ بملاحظةِ عالَمٍ شاسعٍ من الإبداع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يكُن جمالُها الخارجي إلا مدخلاً مُتواضعاً لجمالِ روحها، روح تكتنفُها قوَّة التحدّي، اعتادَت تلك الجميلة أن تستقرئ مشاعرَ مَن حولها، اعتماداً على شدَّةِ الصَّوت وحدَّتهِ، تمتلكُ قدرةً غير مسبوقة لإضافة نكهة مختلفة تجعلُ الحياةَ تتجلَّى بمعانٍ أسمى، حدَّثتني عن عملها الَّذي تُساعِد فيه بتعليمِ مَن \"أصابَهم الظَّلام\"، حسبَ تعبيرها، الخروجَ من عتمتهم بطُرقٍ تطوَّرَت كثيراً في الآونةِ الأخيرة، عوامل الدَّهشة المحيطة أربكَتني، تخيَّلتُ لو أنَّ شخصاً يتمتَّعُ بنعمةِ البصر يقودُ ذلك المكان، كيف أنَّه سيكون عاجزاً عن إضافة ذلك الصَّفاء والجمال! ومن الأشياء الَّتي سبَّبت لي الدَّهشةَ أيضاً، أنَّني رأيتُ ألواناً، وزهوراً، وكتباً!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عدتُ من لقائي الأوَّل مفتوناً، مُفكَّكاً، وبدا المشهدُ أمامي كأنَّ تلك السَّاحرةَ تعيدُ بنائي من جديد، راجعتُ التَّفاصيلَ كثيراً، خطرَت لي العديد من القصص والأسئلة، وقرَّرتُ أن أبدأ بها في لقائي التَّالي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طلبَت منّي أن نجلس بين الأشجارِ في الحديقة، تُرى هل تتذكَّر كيف كانَ شكلُ الشَّجرة ولونها؟ لم أحتفظ بالسُّؤال طويلاً:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تتذكَّرين الألوانَ؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، لا...صمتَت، طالَ صمتُها، كسرَتْهُ بعد أن وصلَت لعباراتٍ يمكنُها أن تشرحَ تشتُّتَ الإجابة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ أن تبدأَ الذِّكرياتُ بالزَّوال لا يتبقَّى إلَّا المشاعر، أتذكَّرُ شعوري بالألوان.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أثارَتِ الإجابةُ فضولاً غير مسبوق:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شعوركِ بالألوان!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتذكَّرُ أنّي كنتُ كلَّما نظرتُ للسَّماء ورأيتُ لونَها شعرتُ بخفَّةٍ تجتاح أطرافي، تجبرُني على التَّحليق عالياً كالطّيور، كأنَّني أمتلكُ جناحين يحملانني بعيداً، ما زلت اذكرُ الشّعورَ، ما زال ينتابُني كلُّما تذكَّرتُ رحابةَ السَّماء.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بفضولٍ تجاوزَ حدودَ اللَّباقةِ انطلق سؤالي التَّالي:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بماذا تشعرين عندَ تذكُّرِ لون الأشجار؟")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بالحياة، الحياةُ شعورٌ وليسَت حالةً، الحياةُ هي فرصةٌ للارتقاء بما تملك، تطوير لمخزون البشريَّة عبر العصور، تجربة لصناعة الاختلاف، وابتداع أنماطِ سعادةٍ جديدة.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أي مرحلةٍ وصلتِ في دراستِكِ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنهيتُ المرحلةَ الابتدائيَّة فقط، في مُنتصَفِ المرحلة المتوسّطةِ حلَّ الظَّلامُ، لم يكُن هناك مدارسُ متخصِّصة لحالاتٍ تشبهُ حالتي، ساعدَني بعضُ الأساتذة بما هو متوفِّر لديهم، بعد ذلك جاءَت ثورةُ الملفَّات الصَّوتيَّة، وبتُّ أستمعُ للعديد من الكُتب بلُغاتٍ متعدِّدة.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتجيدين أكثر من لغة؟!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، كانَ يجب أن أضيءَ ظلامي، بحثتُ عن المعرفة، رغبتُ بمعرفة تجاربَ البشريَّة عبر مسيرة حضارتها، كان من المُمكن أن أعرفَ ذلك بلُغةٍ واحدة، ولكن اللُّغةَ الأمّ هي الَّتي تحملُ أكبرَ حقيقة ممكنة من مشاعر الكاتب، عندَ التَّرجمةِ للغة أخرى يضيف المترجِمُ مشاعرَ إضافيَّة، تساعدُ أحياناً، وتغيُّر أحياناً أخرى من شفافيَّة المعنى الأصليّ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل جربتِ الكتابةَ يوماً؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، أكتبُ أفكاري، ثمَّ أشعرُ بالنَّدم.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولماذا ذلك الشّعور؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يجب على الأفكار أن تبقى حرَّة، عليها أن تكون عابرةً، الأفكار لا تحبُّ القيودَ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاولتُ أن أُظهِر لها مدى اهتمامي بكلامها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يبدو أنَّ هناك تناقُضاً فيما سمعت، أنتِ الآن تحدَّثتِ عن الحضارة، والحضارةُ بمجموعها أفكارٌ تحوَّلت مِن أطياف متنقلةٍ لحقائقَ ثابتةٍ قادَتِ البشريَّةَ نحو الصَّواب.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الصَّوابُ كلمةٌ متقلِّبة.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أفهم!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يختلفُ الصَّوابُ بين فردٍ وآخر، لو تعرَّفْتَ على تناقُضاتِ الحضارات المختلفة لأدركتَ أنَّ صوابَ بعضها يُعتَبرُ أكبر خطأٍ في أُخرى؛ الصَّواب كلمةٌ لا تُقاسُ إلَّا: بواقعِ الظُّروف المحيطة، ومشاعر الأفراد، ومستويات إدراكهم.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غرابةُ الفكرةِ لم تمنعْني من إدراكِ أهميَّتها والتَّفكُّرِ في معناها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("معكِ حقٌّ، يختلفُ الصَّوابُ حسبَ تفسير كلِّ شخصٍ لمعطيات واقعٍ يراها من وجهةِ نظره.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تردَّدَتْ قليلاً قبلَ طرحِها لفكرتِها التَّالية، وقالَت:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما تسيرُ به الآن يُعتبَرُ خطأً بمنظور شريحةٍ كبيرة من البشر، يعتقدون أنَّ انعدامَ الرُّؤيا هي عاملٌ نقصٍ لا يمكن تعويضه للتغلُّبِ على مفردات حياةٍ يوميَّة، وصواب بمنظور آخرين، يعتقدون أنَّ البصيرةَ هي الغاية من البصر، ووجودها غير مقترنٍ به.")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يبدو أنَّ العلومَ الفلسفيَّة تشكِّلُ ركناً هاماً من اهتمامِكِ!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفلسفةُ هي أمّ العلوم، انطلقَتْ منها تفاصيلُ العلوم الجزئيَّة الأُخرى، عندَما تعرَّفتُ على سيرةِ حياة الفلاسفة عشتُها في مخيّلتي، تمنيَّتُ لو كنتُ قادرةً على التدخُّل بها؛ لأُعيدَ صياغة بعضها.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسمتُ، وقاربتُ على الضَّحكِ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ها نحن نقتربُ من أحلامٍ كبيرةٍ جدّاً!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الحلمُ حقٌّ مشروعٌ للجميع، لا يحكمُه أيُّ قانون، يتجرَّدُ مِن تبعيتهِ للزَّمان والمكان، تنتقلُ عبره")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لعوالَم بعيدة، يمكنُكَ أن تكونَ فاعلاً فيها، وتحقِّقَ انتصاراً يشعرُكَ بالوجود الفعلي؛ لأنَّكَ أضفْتَ لنفسِكَ ثقَّةَ القدرةِ على التَّفكير، ومجاراة التَّاريخ والأحداث.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعترفُ أنَّك تضيفين بُعداً جديداً لكلِّ مفهومٍ، اعتَقَدْتُ أنّي أدركْتُ كلَّ أبعادِه فيما مضى!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندَما يُحرَمُ الإنسانُ إحدى حواسه يستثمرُ ما تبقَّى بطاقتهِ القُصوى، يعملُ ويثابر على تسخيرِ الخيال لتعميق الشّعور، يبحرُ بعيداً في طيَّات النَّفس، يختبرُ جواهر ذاتِه، ويصقلُ أفكاره، تسكنُ الحكمة كلماته، ويصبحُ خبيراً في تصريف أفعال البشر.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتهى اللّقاءُ، فتحَت ميا بمفاتيح سحرها طاقاتِ معرفةٍ جديدة، وأطلقَت أفكاراً كثيرة، أجهدتُ نفسي لجمعِ ظلالها المبعثرة، كتبتُ العديدَ من المقالات والأفكار، وبدأتُ برسم الخطوط الأساسيَّة لروايةٍ هي بطلتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ساورَني شعورٌ جديد تركَ أثراً أعادَ فيه ترتيبَ بنود العلاقة مع النِّساء، وبتُّ أجني كنوزاً قيّمة، أضيفُ من خلالها مخزوناً روحيّاً لما كنتُ أدعوه موهبة، أطلقَت تلك الفتاةُ شيطانَ شعري، وباتَ صديقاً لصيقاً يُطلقُ من خلال كلماتي أجملَ القوافي، تطوَّرت مهارتي، اجتزتُ حدودَ النمطيَّة، ودخلتُ عالَمَ الإبداع الواسع، تعلَّمتُ منها أفكار المطلقِ والمجرَّد، قاربتُ بين الوجودِ والعَدم، اعترفتُ بسحرها الَّذي أخرج ماردَ إنسانيَّتي نحوَ أبعاد أغنى، وأيقنتُ أنَّها تمتلكُ امتداداتٍ حقيقيَّة، يمكنُها أن تصنع من خلالها كياناً إبداعياً ملموساً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد مرورِ عامٍ كامل على علاقةٍ قَدَّسْتُ كلَّ ما فيها، قرَّرت ميا الابتعادَ، بلغَني قرارَها عن طريقِ صديقي الطَّبيب، نقلَ لي الخبر، بكثيرٍ من الحزن والأسى، لم يُساعدني تكتُّمُه على إيجاد دواءٍ لاعتلال أصابني في الصميم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("راجعْتُ كلَّ لقاءاتنا الَّتي وثَّقتُ معظمَ مواضيعها، راجعتُ ملاحظاتي عن مشاعري الَّتي تلتهبُ وتتأجَّج، قرأتُ مذكَّراتي ومقارناتي بين أيَّامٍ تُسمَّى خطأ، حياة، وبين أيَّامِ حياتي الحقيقيَّة الَّتي عرفتُ معناها بالقُربِ منها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قمتُ بإعداد عدّة سيناريوهات فسَّرتُ فيها سببَ إخراجي من حياتها، ربَّما شعرَت بعجزٍ أو قصور ما، أو أنَّها اعتقدَت أنَّني سأنسحبُ من حياتها، أو ربَّما أصابَها تعبٌ جسدي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ التمعُّن بالقائمة المليئةِ بالتوقُّعات والاحتمالات المتعدِّدة، قرَّرتُ الدّخول بتحدٍ مع الواقعِ والزَّمن ونفسي، عرفتُ أنَّ سعادتي محتجزةٌ في روحها، وأنَّ حياتي لن تستعيدَ غايتها إلَّا بقربها، أطلعتُ صديقي على خطَّة مثابرتي وإصراري على نيل محبّتها، تردَّدَ كثيراً؛ شرحَ لي حساسيَّة مشاعرها، ووصفَ لي حالها، ولم يزدني ذلك إلَّا ثباتاً على فكرتي الَّتي قرَّرتُ من خلالها محاربةَ كلّ الثَّوابت لتحقيقها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رجوتُهُ استقبالي في منزلِ العائلة، بعدَ حصار شديد وافَق متنصِّلاً من عبء الحضور أثناء الزّيارة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتقيْتُ باقةَ أزهارٍ كبيرة، وخاطبتُ نفسي، أنبتُها على غبائها في اختيارٍ غير موفَّق، اختيار غير قادر على تركِ انطباعٍ عندَ مَن تجاوزَ في رؤيته حدودَ الألوان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاولتُ في طريقي عقدَ هدنةٍ مع قلبي المضطرب، ناورتُ كثيراً، أقنعتُه بتخفيف صدى ضربات سبَّبتْ لي اهتزازاً واضحاً، ورعشةً مرئيَّة في نهاية أصابعي، المعضلة الأُخرى تمثَّلَت في التغلُّب على بردٍ استنزفَ كلَّ طاقتي، وصلتُ مجرَّداً من كلِّ أسلحتي، مستجدياً حبّاً ودفئاً وحياة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَت ميا بانتظاري، أعادَت ابتسامتُها الدَّائمة دفئي، وعدْتُ شخصاً قادراً على متابعة حياةٍ وعد نفسه بها، تناثرَتْ كلُّ الكلمات، كانَ من الممكن أن أعوِّلَ على لغةٍ يُعرِّفها العاشقين بمصطلح لا يعمل في حالتنا \"لغة العيون\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدا، ولأوَّل مرَّةٍ في حياتي، حاجزُ الصَّمت عملاقاً ضخماً، وأنا المتكلِّمُ والكاتب الَّذي طوَّعَ حروفَ لغته! فكَّرتُ في تلك اللَّحظة بالموت، الموتُ حالة نعجزُ فيها عن التَّعبير، يقول العلم: إنَّ الحواسَّ تحتفظُ بقدرتِها على استقبال المنبِّهات المختلفةِ بعد الموت، ولكنَّ الميّتَ يعجزُ عن الاستجابة لها، والاستجابةُ بالتَّعبير هي قوّةُ الوجود، هي المسؤولة عن خصوصيَّةِ شخصيَّاتنا واختلافاتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قبيلَ التغلُّب على ضعفي، أنارَت كلماتُها عتمَ ضيائي:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعتقدُ أنَّ أزهارَك جميلةٌ متعدّدةُ الألوان!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما هو شعورُكِ نحوها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جميلٌ جدّاً!")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شعرتُ أنَّني استطعتُ الوصولَ للسَّطح، بعد غرقٍ باتَ وشيكاً، ولم أجدْ غيرَ كلمةِ: (شكراً).")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تأخَّرتَ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أستطعْ وضعَ الكلمةِ بسياقِ حوارٍ مناسب، هل هي سؤال؟ نظرتُ إلى السَّاعة، ظنّاً منّي أنَّ المقصودَ هو توقيتٌ غفلتُ عنهُ، وأدركتُ مُتأخِّراً عمقَ ما تعنيه بما قالَت، انتظمَت أنفاسي أخيراً، واستعدتُ السَّيطرةَ على حروفي:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أجتزْ في حياتي اختباراً بهذه الصُّعوبة!")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الاختبارُ مرحلةٌ هامّة من مراحل التعلُّم، ندركُ فيه ما نعرفُ، وما يجبُ أن نعرفَ، أين هي مواطنُ ضعفِنا، ومواقع قوّتنا، أتمنَّى أن تكونَ قد أدركتَ احتياجاتِكَ الحقيقيَّة!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا أحتاج إلَّا أنَّ أكونَ بالقُربِ من عالمكِ النَّقي.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ليس نقيّاً تماماً، فيه الكثير من الشَّوائب، ستعملُ على التَّسبُّبِ بضيق في التنفُّس، وشكٍّ في القدرةِ على الاستمرار!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سنتعلَّم معاً كيف يمكنُ التغلُّب على تلك الشوائب.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تؤمنُ بنفسِكَ؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شعرتُ أنَّ السُّؤالَ فخٌّ محكمُ البناء، في أثناءِ التَّفكير وقبلَ الوصول للإجابة، قاطعَتني:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندَما بدأ ظلامي، دخلتُ ككلِّ البشر عندَ إصابتهم بحادثٍ جللٍ في حالةِ إنكارٍ عنيدةٍ، كنتُ في كلِّ صباحٍ، وقبلَ أن أفتحَ عينيَّ أتخيَّلُ شكلَ الضياء، وملامح أمي، كنتُ واثقةً أنَّ ذلك اليوم الَّذي سأستعيدُ فيه الرّؤية قريبٌ جدّاً، طال انتظاري؛ شعرتُ بحزنِ والدي وألم والدتي، سمعتُ صوتَ بكاءِ أخي، (تَنَهدَتْ وتابعتْ): أن ينتابَكَ الحزنُ، هو طبيعة بشريَّة، شعورٌ يعرفُه الجميعُ، وفي حالَّتي كنتُ أنا سبب حزنِ الآخرين، (أَخَذَتْ نفَساً عميقاً، أوحى بمعنى الانتقال): بعدَ أن أدركتُ أنَّني سببُ شقائِهم، قرَّرتُ أن أتحوَّل لسببٍ من أسباب بهجتهم، تمثَّلتِ البدايةُ بالتغلُّب على حزني، بالتغلُّب على شعورِ الفقدِ واستحضارِ مشاعر امتلاك القُدرةِ على المضي بقوَّة، تَوَّلد بعدَ ذلك إيمانٌ مَدَّني بعزيمةٍ مستدامة، واجهتُ لحظاتِ العتمة العنيفة، بقُدرتي على إنارة ظلامٍ يُمكنُ أن يصيب الآخرين، والظَّلام هنا مفهوم متعدّد المعاني، متعدّد الخصائص، يمكنُ أن يصيبَ الجميعَ، بمَن فيهم أولئك القادرين على ملاحظة ضوء الشَّمس.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لخَّصَت جميلتي قصَّتي معها، وصفَت ما أصاب قلبي المُعتم من ضياء استطاعَ تحويله لنورٍ نابض:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتِ مصدرُ نوري، أنتِ روحٌ تصبُّ الحياةَ على كلِّ من يعتقدُ أنَّها بعيدةٌ عنه.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهايةُ قصّتي مع ميا، تشبهُ نهايةَ قصَّة سندريلا، الَّتي جمعَتها مع الأمير، وقضيا معاً حياةً مليئةً بالمحبّة، إلَّا أنَّ ميا هي الَّتي أنقذَتْنِي من ظلمٍ وظلامٍ عانيتُ منهُ، أعادَت رسمَ المعاني، وأكسبَتِ المفاهيمَ ألواناً لا يراها إلَّا من أَجبرَ نفسه الارتقاءَ لسماء الإنسانيَّة، وأطلقَ العنان لأفكاره، وأعلنَ الحياةَ سعادةً للرّوح.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قضينا معاً ثلاثين عاماً، أوقَفْتُ خلالها كتابة روايتي، تنفيذاً لرغبتها، امتلأَ بيتَنا بعائلةٍ نبتَت المحبّة بينها، وأثمرَت؛ وفي غفلةٍ من الزمن تناثرَ أفرادها وعدنا أنا وميا لحالةِ العشقِ الأولى، قضينا معاً أيَّاماً ولحظاتٍ، ألبسْنا فيها كلَّ المعتقداتِ والتفاسير القديمةِ حُللاً جديدة، ألهمَتني، تحوَّلَت لأيقونةِ إبداعٍ نابضةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولأنَّ لحظاتِ السَّعادة تشبهُ لمعان الماس، قويَّة ومؤثِّرة، أقنعْتُ ميا بروايتي الَّتي انتظرَتني دهراً، موافقَتُها أتَت تلبيةً لخيالاتٍ أصابَتْها بشيءٍ من نورٍ وحبّ وإصرارٍ ثابرْتُ عليه، عدتُ لروايتي، كتبتُ عنها، سكبتُ روحَها النَّيرة، وشغفَها في العطاء، وثَّقتُ لحظاتِ انتصارها، ووصفتُ سحرَ إصرارها على السَّعادة، اعتذرتُ منها على كتابة روايتي، أعتقدُ أنَّها غفرَت لي نكثَ وعدٍ مكَّنَني من ملاحظةِ ألوانٍ مختلفةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حقَّقَت الرّوايةُ نجاحاً باهراً، أشعرُ أنَّ مَن كتبَها شخصٌ مختلفٌ تقمَّص نفسي القديمة، كانَت رواية مختلفة، خَلَطَت الخيالَ بأحلامِ الواقع، وغزت آثارَ إنسانيَّتنا المتعبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألَني أحدُ القرَّاء: (كيفَ خطرَت لكَ تلك الفكرة؟ هل يمكنُ أن نجدَ مثالاً واقعيّاً لبطلتها؟ هل يمكنُ لأنثى في الواقع، أو الخيال، أن تتمتَّعَ بالسِّحر والصَّبر والقوَّة ؟) تأمَّلتُه قليلاً، وقلتُ لهُ: (ساندريلا).")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1-8-2021")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0